module.exports = __webpack_public_path__ + "static/icons/person-9.e5a953d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nps/person-9.svg
// module id = BUf0
// module chunks = 1